/* import __COLOCATED_TEMPLATE__ from './phone-handover.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { type FinSetupBehaviorSaveParams } from 'embercom/lib/operator/fin/types';
import type Store from '@ember-data/store';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import type {
  HandoverConfiguration,
  FinVoiceNumberConfigurationHandoverConfiguration,
} from 'embercom/models/fin-voice/number-configuration';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';

interface Args {
  accordion: $TSFixMe;
  ruleset: $TSFixMe;
  numberConfiguration: FinVoiceNumberConfiguration;
  partialSave: (params: FinSetupBehaviorSaveParams) => void;
}

export default class PhoneHandover extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare finVoiceConfigService: FinVoiceConfigService;
  @service declare notificationsService: $TSFixMe;

  get isDisabled() {
    return !this.numberConfiguration;
  }

  get numberConfiguration() {
    return this.args.numberConfiguration;
  }

  get isAnytimeConfig() {
    return !this.numberConfiguration?.predicates?.officeHoursComparison;
  }

  get openSectionId() {
    return this.args.accordion.accordionAPI.openSectionId;
  }

  get hasHandoverConfig() {
    return Object.keys(this.numberConfiguration?.handoverConfiguration || {}).length > 0;
  }

  @action
  getHandoverSummary(_: string, value: HandoverConfiguration) {
    if (!value) {
      return '';
    }

    if (value.type === 'handover-to-voicemail' || value.type === 'handover-to-human') {
      let assigneeId = value.config.assigneeId;
      return this.appService.app.assignableAdmins.findBy('id', assigneeId)?.name;
    }

    return '';
  }

  @action
  async updateHandover(handoverConfig: FinVoiceNumberConfigurationHandoverConfiguration) {
    try {
      await this.finVoiceConfigService.updateHandoverConfiguration(
        this.numberConfiguration.workspacePhoneNumber,
        handoverConfig,
      );
      this.notificationsService.notifyConfirmation(
        this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.success'),
      );
    } catch (error) {
      console.error('Error updating handover configuration', error);
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('operator.fin.setup.setup-and-go-live.notification-messages.failure'),
      });
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::PhoneHandover': typeof PhoneHandover;
  }
}
